import { jumpToPageByH5 } from '@/utils/fn';
import styles from '../styles/common.less';

export const FixedInviteFooter = ({ btnText = '马上分享领大奖', className }) => {
  return (
    <div className={`${styles.fixedFooter} ${className}`}>
      <button
        className={styles.footerBtn}
        onClick={() => jumpToPageByH5('/invite/share', { needLogin: true })}
      >
        {btnText}
      </button>
    </div>
  );
};
export default FixedInviteFooter;
